<template>
    <button
            v-show="status!==null"
            type="button"
            :class="elClass"
            :disabled="disabled"
            @click="execute"

    >{{ buttonLabel }}
    </button>
</template>

<script>
import * as toastr from 'toastr'

export default {
  components: {},
  props: {
    date: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      status: null,
      elClass: 'btn',
      disabled: false,
      buttonLabel: null,
    }
  },
  watch: {
    date: function (date) {
      this.getStatus(date)
    },
    status: function (status) {
      switch (status) {
        case 'default':
          this.elClass = 'btn btn-success'
          this.disabled = false
          this.buttonLabel = Translator.trans('warehouseman.main.generate.button.execute')
          break
        case 'generating':
          this.elClass = 'btn btn-default'
          this.disabled = true
          this.buttonLabel = Translator.trans('warehouseman.main.generate.button.wait')
          break
        case 'generated':
          this.elClass = 'btn btn-danger'
          this.disabled = false
          this.buttonLabel = Translator.trans('warehouseman.main.generate.button.abort')
          break
      }
    },
  },
  mounted: function () {
    this.getStatus(this.date)
  },
  methods: {
    getStatus(date) {
      this.$http.get(Routing.generate('api_get_plan_status', { date: date })).then(
        response => {
          this.status = response.data
        },
        response => {
          this.handleAjaxError(response)
        }
      )
    },
    trans(name) {
      return Translator.trans(name)
    },
    execute() {
      switch (this.status) {
        case 'default':
          this.generate()
          break
        case 'generated':
          this.abort()
          break
      }
    },
    generate() {
      this.status = 'generating'
      this.$http.post(Routing.generate('plan_generate', { date: this.date })).then(
        () => {
          toastr.success(Translator.trans('warehouseman.main.generate.success'))
          this.status = 'generated'
        },
        response => {
          this.handleAjaxError(response)
        }
      )
    },
    abort() {
      this.$http.post(Routing.generate('api_post_plan_abort', { date: this.date })).then(
        () => {
          toastr.success('Ruchy zostały usunięte')
          this.status = 'default'
        },
        response => {
          this.handleAjaxError(response)
        }
      )
    },
  },
}
</script>
